/**
 * Created by mac on 4/21/20
 */

const EditorViewBase = cc.Node.extend({
    ctor: function (editor) {
        this._super();

        this.editor = editor;

        this.setAnchorPoint(0.5, 0.5);
        this.onResize();

        if (!["merge", "farm"].includes(cleverapps.config.type) && cleverapps.config.name !== "wordsoup") {
            const levelNoBlock = new EditorLevelView(editor);
            this.addChild(levelNoBlock);
        }

        if (!["merge", "farm"].includes(cleverapps.config.type) && cleverapps.config.name !== "wordsoup") {
            const controls = new EditorControlsView(editor);
            this.addChild(controls);
        }
    },

    onResize: function () {
        const winSize = cleverapps.resolution.getSceneSize();
        this.setContentSize(winSize.width, winSize.height);
        this.setPosition(winSize.width / 2, winSize.height / 2);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    EDITOR_GREEN_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.GREEN
    },

    EDITOR_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.WHITE,
        name: "formal"
    },

    INCDECBLOCK_AUTO_TEXT: {
        size: 32,
        color: cleverapps.styles.COLORS.MESSAGE_GREEN
    },

    EDITOR_BIG_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        name: "formal"
    },

    EDITOR_BLUE_TEXT: {
        size: 22,
        color: cleverapps.styles.COLOR_BLUE
    }
});